var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5C11.7352 17.5 13.4166 16.8984 14.7579 15.7976C16.0992 14.6968 17.0174 13.165 17.3559 11.4632C17.6944 9.76135 17.4324 7.9948 16.6144 6.46453C15.7965 4.93425 14.4732 3.73492 12.8701 3.0709C11.267 2.40689 9.48332 2.31926 7.82287 2.82295C6.16242 3.32664 4.72799 4.39049 3.76398 5.83322C2.79997 7.27596 2.36604 9.00832 2.53611 10.7351C2.70619 12.4619 3.46975 14.0764 4.6967 15.3033",
    stroke: "#7161BA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5L12.5 12.5",
    stroke: "#7161BA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.5L7.5 12.5",
    stroke: "#7161BA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRing);
export default __webpack_public_path__ + "static/media/close_ring.a5d7d974f1036fc8715a5a134ea52c18.svg";
export { ForwardRef as ReactComponent };